import { render } from "./mihadhara.vue?vue&type=template&id=0197630d"
import script from "./mihadhara.vue?vue&type=script&lang=js"
export * from "./mihadhara.vue?vue&type=script&lang=js"
script.render = render

export default script